import { render, staticRenderFns } from "./SellerDocumentation.vue?vue&type=template&id=134604f6&scoped=true&"
import script from "./SellerDocumentation.vue?vue&type=script&lang=js&"
export * from "./SellerDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./SellerDocumentation.vue?vue&type=style&index=0&id=134604f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134604f6",
  null
  
)

export default component.exports